import { inject, observer } from 'mobx-react';
import React from 'react';
import CartStore from '../../stores/Cart';
import ProductBlock from '../ProductBlock';
import Translate from '../Translate/Translate';
import './styles/index.scss';

interface Props {
  cart?: CartStore;
}

@inject('cart')
@observer
export default class Favourite extends React.Component<Props> {
  constructor(props: Props) {
    super(props);

    this.removeFavourite = this.removeFavourite.bind(this);
  }

  removeFavourite(product) {
    const { cart } = this.props;
    cart.toggleFavourite(product.slug);
  }

  render() {
    const { cart } = this.props;
    const favourites = cart.favourites.map((favourite) => {
      const product = cart.getProduct(favourite.id);

      return <ProductBlock key={favourite.id} product={product} />;
    });

    return (
      <div className="mt-0 mb-20 mx-auto">
        <h2 className="mx-0 my-5 lg:my-8 text-4xl leading-12 font-axi-bold">
          <Translate component="favourite" keyword="title" />
        </h2>
        <div className="page-favourites__grid">{favourites}</div>
      </div>
    );
  }
}
